import { client } from '../../../shared/services/apiClient';

export const signUp = async (formData: URLSearchParams): Promise<any> => {
  return client(false, false, true).post<any>('/auth/register', formData);
};

export const resendVerification = async (email: string): Promise<any> => {
  return client(false, false).post<any>('/auth/resend-verification', { email });
};

export const getAuthConfig = async (): Promise<any> => {
  return client(true, false).get<any>('/auth/auth-config');
};
